
import http from './http';


export const getFavinfo = async (lang) => {
  return http.get(`/api/profile/favinfo?UIC=${lang}`, {  "credentials": 'include' })
}

export const getSubscription = (lang) => {
  return http.get(`/api/profile/subscription?UIC=${lang}`, {  "credentials": 'include' })
}

export const getPersonalInfo = (param) => {
  // ${param.webId}/test?UIC=${param?.lang}&token=${param.token}
  // const betAcct = !param.bettingAccount || param.bettingAccount === 'undefined' ? 'NA' : param.bettingAccount
   return http.get(`/api/profile/personinfoSolace?UIC=${param?.lang}`, 
    {  
      "credentials": 'include',
      "headers":{
        "webuserid": param.webId, 
        "token": param.token
      }
    })
}

export const getJockey = (lang, q) => {
 return http.get(`/ajax/sj.ashx?UIC=${lang}&EP=BS&q=${q}&limit=10`)
}

export const validJockey = (lang, q) => {
  return http.get(`/ajax/vj.ashx?UIC=${lang}&EP=BS&q=${q}&_=${new Date().getTime()}`)
}

// Trainer
export const getTrainer = (lang, q) => {
 return http.get(`/ajax/st.ashx?UIC=${lang}&EP=BS&q=${q}&limit=10`)
}


export const validTranier = (lang, q) => {
  return http.get(`/ajax/vt.ashx?UIC=${lang}&EP=BS&q=${q}&_=${new Date().getTime()}`)
}
// Horse
export const getHorse = (lang, q) => {
 return http.get(`/ajax/sh.ashx?UIC=${lang}&EP=BS&q=${q}&limit=10`)
}

export const validHorse = (lang, q) => {
 return  http.get(`/ajax/vh.ashx?UIC=${lang}&EP=BS&q=${q}&_=${new Date().getTime()}`)
}
// team
export const getTeam = (lang) => {
 return http.get(`/ajax/sf.ashx?UIC=${lang}&FOOTBALL=TEAM`)
}

export const getLeague = (lang) => {
 return http.get(`/ajax/sf.ashx?UIC=${lang}&FOOTBALL=LEAGUE`)
}

export const postFavinfo = async (lang, body) => {
  return http.post(`/api/profile/favinfoArkle?UIC=${lang}`, { 
    webUserId: window.sessionStorage.getItem('userId'), token: window.sessionStorage.getItem('jwtToken'), ...body }, {  "credentials": 'include' })
}

export const postSubscription = async (lang, body) => {
  return http.post(`/api/profile/subscriptionArkle?UIC=${lang}`,
     { 
    webUserId: window.sessionStorage.getItem('userId'), token: window.sessionStorage.getItem('jwtToken'), ...body }, {  "credentials": 'include' })
}
